export default __webpack_public_path__ + "static/media/logo-mmr-min.f907a16a.svg";